var _path, _polygon, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "hornIconTitle"
  }, "Bullhorn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "hornIconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M6.5,9 C8.33333333,9 10.1666667,9 12,9 C14,9 16.3333333,7.33333333 19,4 L19,19 C16.3333333,15.6666667 14,14 12,14 C10.1666667,14 8.33333333,14 6.5,14 L6.5,14 C5.11928813,14 4,12.8807119 4,11.5 L4,11.5 C4,10.1192881 5.11928813,9 6.5,9 Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7 14 9 20 13 20 11 14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11,9 L11,14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorn);
export default __webpack_public_path__ + "static/media/horn.fc1501d0587e931d13bf9584a68c3dae.svg";
export { ForwardRef as ReactComponent };